import React, { useState } from 'react'
import { Accordion, Card, Button } from 'react-bootstrap'

const Index = () => {

    const [activeTab, setActiveTab] = useState("0")

    return(
        <div className="tab-section-container">
            <div className="inner-tab-section-container">
                <p className="introduction-text">
                    Det finnes ingen grense på hvor mange kontakter du kan ha i en kontaktliste, og disse brukes for å definere målgruppen for e-postutsendelsene dine. Dersom du mot formodning skulle ha flere kontakter i en kontaktliste enn det du har e-poster tilgjengelig, vil kun en andel av listen motta e-posten du sender ut og resten utebli.
                    <br/><br/>
                    Du kan velge om du vil legge til kontakter i listen din enkeltvis, eller laste opp en hel .csv-fil og hente ut kontaktene automatisk. Vennligst merk deg at jo større liste du laster opp, jo lenger tid tar det å hente ut dataene.
                </p>
                <div className="accordion-container">
                <Accordion className="company-accordion" defaultActiveKey="0" activeKey={activeTab}>
				<Card className="single-card top">
					<Card.Header className="card-header">
						<Accordion.Toggle className="card-toggle" as={Button} variant="link" eventKey="0" onClick={() => setActiveTab("0")}>
							<button className={`collapse-button ${activeTab === "0" ? "active":""}`}>{activeTab === "0" ? <i class="fas fa-minus"></i>:<i class="fad fa-plus"></i>}</button>Opprett en ny kontaktliste
						</Accordion.Toggle>
					</Card.Header>
					<Accordion.Collapse eventKey="0">
						<Card.Body className="card-body">
                            <p className="description-text">Prosessen for å opprette en kontaktliste er rask og enkel, og du gjør det slik:</p>
							<ol className="description-list">
								<li>Gå til <span className="bold">"Kontaktlister"</span> under <span className="bold">"Utsendelser"</span> fra menyen til venstre.</li>
								<li>Trykk på <span className="bold">"Ny kontaktliste"</span>-knappen øverst i høyre hjørne.</li>
								<li>Skriv inn navn på kontaktlisten, beskrivelse er frivillig.</li>
								<li>Trykk deretter på <span className="bold">"Legg til"</span>-knappen.</li>
							</ol>
						</Card.Body>
					</Accordion.Collapse>
				</Card>
                <Card className="single-card">
					<Card.Header className="card-header">
					    <Accordion.Toggle className="card-toggle" as={Button} variant="link" eventKey="1" onClick={() => setActiveTab("1")}>
                            <button className={`collapse-button ${activeTab === "1" ? "active":""}`}>{activeTab === "1" ? <i class="fas fa-minus"></i>:<i class="fad fa-plus"></i>}</button>Legg til kontakter enkeltvis
						</Accordion.Toggle>
					</Card.Header>
					<Accordion.Collapse eventKey="1">
						<Card.Body className="card-body">
							<p className="description-text">For å laste opp flere kontakter fra en CSV-fil gjør du dette:</p>
							<ol className="description-list">
								<li>Trykk på <span className="bold">"Legg til kontakter"</span>-knappen over kontaktlisten.</li>
								<li>Velg <span className="bold">"Singel felt"</span> fra alternativet i menyen som vises.</li>
								<li>Skriv inn detaljene på kontakten din.</li>
								<li>Til slutt, trykk på <span className="bold">"Gå videre"</span>-knappen.</li>
							</ol>
						</Card.Body>
					</Accordion.Collapse>
				</Card>
                <Card className="single-card">
					<Card.Header className="card-header">
					    <Accordion.Toggle className="card-toggle" as={Button} variant="link" eventKey="2" onClick={() => setActiveTab("2")}>
                            <button className={`collapse-button ${activeTab === "2" ? "active":""}`}>{activeTab === "2" ? <i class="fas fa-minus"></i>:<i class="fad fa-plus"></i>}</button>Legg til kontakter med CSV-fil
						</Accordion.Toggle>
					</Card.Header>
					<Accordion.Collapse eventKey="2">
						<Card.Body className="card-body">
                            <p className="description-text">For å laste opp flere kontakter fra en CSV-fil gjør du dette:</p>
							<ol className="description-list">
								<li>Trykk på <span className="bold">"Legg til kontakter"</span>-knappen øverst på siden.</li>
								<li>Velg <span className="bold">"Fra CSV-fil"</span> fra alternativet i menyen som vises.</li>
								<li>Dra ønsket .csv-fil inn i boksen og trykk på <span className="bold">"Gå videre"</span>-knappen.</li>
								<li>Definer datatyper for hvert felt hentet ut fra radene i filen du har valgt.</li>
								<li>Når dette er gjort, trykk til slutt på <span className="bold">"Gå videre"</span>-knappen.</li>
							</ol>
							<p className="description-text">Prosessen for å laste opp kontaktene fra CSV-filen din vil da starte umiddelbart, og avhengig av størrelsen på kontaktlisten kan opplastingstiden variere.</p>
						</Card.Body>
					</Accordion.Collapse>
				</Card>
                <Card className="single-card">
					<Card.Header className="card-header">
					    <Accordion.Toggle className="card-toggle" as={Button} variant="link" eventKey="3" onClick={() => setActiveTab("3")}>
                            <button className={`collapse-button ${activeTab === "3" ? "active":""}`}>{activeTab === "3" ? <i class="fas fa-minus"></i>:<i class="fad fa-plus"></i>}</button>Endre en kontakt i kontaktliste
						</Accordion.Toggle>
					</Card.Header>
					<Accordion.Collapse eventKey="3">
						<Card.Body className="card-body">
                            <p className="description-text">Du kan enkelt endre en kontakt i kontaktlisten din slik:</p>
							<ol className="description-list">
								<li>Trykk på kontakten ønsker å endre fra listen din på venstre side.</li>
								<li>Trykk på <span className="bold">Endre</span>-knappen øverst på høyre side.</li>
								<li>Gjør endringene du ønsker å gjøre.</li>
								<li>Trykk deretter på <span className="bold">"Oppdater"</span>-knappen.</li>
							</ol>
						</Card.Body>
					</Accordion.Collapse>
				</Card>
                <Card className="single-card">
					<Card.Header className="card-header">
					    <Accordion.Toggle className="card-toggle" as={Button} variant="link" eventKey="4" onClick={() => setActiveTab("4")}>
                            <button className={`collapse-button ${activeTab === "4" ? "active":""}`}>{activeTab === "4" ? <i class="fas fa-minus"></i>:<i class="fad fa-plus"></i>}</button>Endre kontaktliste
						</Accordion.Toggle>
					</Card.Header>
					<Accordion.Collapse eventKey="4">
						<Card.Body className="card-body">
							<p className="description-text">Det er kun mulig å endre navn og beskrivelse på kontaktlisten du har opprettet, og slik gjør du det:</p>
							<ol className="description-list">
								<li>Gå til <span className="bold">"Kontaktlister"</span> under <span className="bold">"Utsendelser"</span> fra menyen til venstre.</li>
								<li>Trykk på penn-ikonet i samme rad som navnet på kontaktlisten du ønsker å endre.</li>
								<li>Erstatt navn og beskrivelse som står i tekstfeltene med endringene dine.</li>
								<li>Trykk deretter på <span className="bold">"Oppdater"</span>-knappen.</li>
							</ol>
						</Card.Body>
					</Accordion.Collapse>
				</Card>
                <Card className="single-card last">
					<Card.Header className="card-header">
					    <Accordion.Toggle className="card-toggle" as={Button} variant="link" eventKey="5" onClick={() => setActiveTab("5")}>
                            <button className={`collapse-button ${activeTab === "5" ? "active":""}`}>{activeTab === "5" ? <i class="fas fa-minus"></i>:<i class="fad fa-plus"></i>}</button>Slett kontaktliste
						</Accordion.Toggle>
					</Card.Header>
					<Accordion.Collapse eventKey="5">
						<Card.Body className="card-body">
							<p className="description-text">Dersom du ønsker å slette en kontaktliste gjør du følgende:</p>
							<ol className="description-list">
								<li>Gå til <span className="bold">"Kontaktlister"</span> under <span className="bold">"Utsendelser"</span> fra menyen til venstre.</li>
								<li>Trykk på søppeldunk-ikonet til høyre for navnet på kontaktlisten du ønsker å slette.</li>
								<li>Til slutt bekreft sletting ved å trykke på <span className="bold">"Ja, slett kontaktliste"</span>-knappen.</li>
							</ol>
						</Card.Body>
					</Accordion.Collapse>
				</Card>
			</Accordion>
                </div>
            </div>
        </div>
    )
}

export default Index